<template>
  <div>
    <div class="into">
      <img class="into-icon" :src="img" :alt="title">
      <h2 class="into-title">{{title}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props:['img','title']
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
  .into {
    text-align: center;
    &-icon {
      width: 70px;
      padding: 40px 0 20px;
    }
    &-title {
      padding-bottom: 30px;
      font-size: 22px;
      color: $basecolor;
      font-weight: 700;
    }
  }

    @media screen and(max-width: 768px) {
  .into {
    &-icon {
      width: 50px;
      padding: 20px 0 10px;
    }
    &-title {
      padding-bottom: 20px;
      font-size: 20px;
    }
  }
  }
</style>